export const validateEmail = (email: string): { isValid: boolean; error: string } => {
	const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
	
	if (!email || !email.trim()) {
		return { isValid: false, error: "Email field is required" };
	}
	
	if (!emailPattern.test(email)) {
		return { isValid: false, error: "Please enter a valid email address" };
	}
	
	return { isValid: true, error: "" };
};

export const validate = (formData: any, setErrors: (errors: any) => void) => {
	const tempErrors: any = {};
	const passwordPattern =
		/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&^<>~/`+\-_.#,{}\[\];':"|\\=)(])[A-Za-z\d@$!%*?&^<>~/`+\-_.#,{}\[\];':"|\\=)(]{8,}$/;

	Object.keys(formData).forEach((key) => {
		if (!formData[key as keyof typeof formData]) {
			const fieldName = key.split("_").map((fieldName) => {
				return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} `;
			});

			tempErrors[key] = `${fieldName[0]} ${
				fieldName.length > 1 ? fieldName[1] : ""
			} field is required`;
		}
	});

	if (formData.password && !passwordPattern.test(formData.password)) {
		tempErrors.password =
			"Password must be 8 or more characters with a mix of letters, numbers & symbols.";
	}
	setErrors(tempErrors);
	return Object.keys(tempErrors).length === 0;
};
